<template>

    <div class="container__body container__body--xsm">

        <header class="col-12 margin-b-50">

            <div class="settings">

                <h1 v-if="isCreating">Tilføj ny</h1>

                <template v-else>
                    <h1>Rediger</h1>
                    <ws-dropdown>

                        <template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

                        <template slot="content">

                            <ul>
                                <li><a href="#" @click.prevent="doShowDeleteModal"><i class="fas fa-trash-alt"></i> Slet</a></li>
                            </ul>

                        </template>

                    </ws-dropdown>
                </template>

            </div>


        </header>

        <form class="col-12" @submit.prevent="submitItem">

            <div class="col-12 margin-b-75">

                <label>Navn</label>

                <input class="col-12" type="text" name="title" placeholder="Hvad er navnet?" minlength="2" maxlength="120" required v-model="item.title">

            </div>


            <div class="col-12">

                <button type="submit" class="btn btn--sm btn--primary primary--copper" :disabled="!validateForm || isSaving">

                    <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                    <span v-else>Gem</span>

                </button>

                <router-link href="#" :to="{name:'option.edit.packaging.index', params:{option:this.$route.params.option}}">Annuller</router-link>

            </div>

        </form>

        <ws-modal v-model="showDeleteModal">

            <div class="modal-wrap">

                <div class="modal--sm center">

                    <span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

                    <i class="fas fa-trash-alt icon--lg margin-b-25"></i>

                    <h1>Slet</h1>

                    <h2>Er du sikker på du vil slette {{item.title}}?</h2>

                    <h3>Du kan ikke fortryde denne handling!</h3>

                    <div class="col-12 margin-t-25">

                        <a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteItem">Ja tak</a>

                        <a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

                    </div>

                </div>

            </div>

        </ws-modal>

    </div>
</template>

<script>
export default {
    name: "create-packaging-item",
    data(){
        return {
            item:{
                title:'',
            },
            isSaving:false,
            showDeleteModal:false,
        };
    },
    computed:{
        isCreating() {
            return !this.$route.params.item;
        },
        validateTitle() {
            return this.item.title !== '' && String(this.item.title).length > 0;
        },
        validateForm(){
            return this.validateTitle;
        }
    },
    methods:{
        submitItem(){
            if(!this.validateForm){
                return;
            }

            this.isSaving = true;

            if(this.isCreating){
                return this.createItem();
            }

            this.updateItem();
        },
        createItem(){
            axios.post(`/api/admin/option/${this.$route.params.option}/packaging`, this.item).then((response) => {
                this.item = response.data.data;
                this.isSaving = false;

                this.$router.push({
                    name: 'option.edit.packaging.index',
                    params:{
                        option: this.$route.params.option,
                    }
                })
            })
        },
        updateItem(){
            axios.put(`/api/admin/option/${this.$route.params.option}/packaging/${this.$route.params.item}`, this.item).then((response) => {
                this.item = response.data.data;
                this.isSaving = false;

                this.$router.push({
                    name: 'option.edit.packaging.index',
                    params:{
                        option: this.$route.params.option,
                    }
                })
            })
        },
        doShowDeleteModal(){
            this.showDeleteModal = true;
        },
        deleteItem(){
            this.isSaving = true;
            this.showDeleteModal = false;
            axios.delete(`/api/admin/option/${this.$route.params.option}/packaging/${this.$route.params.item}`).then(response => {
                this.isSaving = false;
                this.$router.replace({
                    name:'option.edit.packaging.index',
                    params:{
                        option: this.$route.params.option,
                    }
                });
            });
        }
    },
    created() {
        if(!this.isCreating){
            axios.get(`/api/admin/option/${this.$route.params.option}/packaging/${this.$route.params.item}`).then((response) => {
                this.item = response.data.data;
            })
        }
    }
}
</script>

<style scoped>

</style>
